import { continueAsRecruiter } from './continueAsRecruiter.js';
import { passwordlessLogin } from './passwordlessLogin.js';
import { linkedInLogin } from './linkedInLogin.js';
import { lastLoginMethod } from './lastLoginMethod.js';
// Import and spread all experiments from the currentExperiments file
export const allExperiments = {
    ...passwordlessLogin,
    ...linkedInLogin,
    ...continueAsRecruiter,
    ...lastLoginMethod,
};
//# sourceMappingURL=index.js.map